<template>
  <div>
    <el-alert
      v-if="marketAppDetail"
      :type="marketAppDetail.status == 'upShelves' ? 'success' : 'warning'"
      style="margin-bottom: 16px"
    >
      <template slot="title">
        <span v-if="marketAppDetail.status == 'upShelves'">
          该交付应用对应的商店应用是 {{ marketAppDetail.name }}, 正在销售中
          <router-link
            :to="{
              name: 'StoreAppManageDetails',
              params: { appID: marketAppDetail.appKeyID }
            }"
            >查看详情</router-link
          >
        </span>
        <span v-else>
          该交付应用对应的商店应用是 {{ marketAppDetail.name }}, 已下架
          <router-link
            :to="{
              name: 'StoreAppManageDetails',
              params: { appID: marketAppDetail.appKeyID }
            }"
            >查看详情</router-link
          >
        </span>
      </template>
    </el-alert>
    <div class="order_detail_main">
      <div v-loading="Loading" v-if="appDetail">
        <div class="info_box">
          <div class="tit" v-if="appDetail.status">
            <el-col :span="4">{{ appDetail.appName }}</el-col>
            <el-col
              :span="20"
              style="
                justify-content: flex-end;
                display: flex;
                align-items: center;
              "
              v-if="
                appDetail.status != 'released' &&
                appDetail.status != 'preparing' &&
                appDetail.status != 'installing'
              "
            >
              <el-button
                style="margin-right: 5px"
                size="small"
                v-permit="'Deliver.DeliveryApp.Redelivery'"
                v-if="appDetail.status == 'failure'"
                @click="handleReDelivery"
                >重新交付</el-button
              >
              <el-button
                style="margin-right: 5px"
                size="small"
                v-permit="'Deliver.DeliveryApp.Release'"
                v-if="
                  appDetail.status == 'closed' || appDetail.status == 'abnormal'
                "
                @click="handleReleaseresources"
                >释放资源</el-button
              >

              <el-tooltip
                class="item"
                effect="dark"
                :disabled="appDetail.regionEnable"
                :content="!appDetail.regionEnable ? '交付环境已经禁用' : ''"
                placement="top"
              >
                <div style="margin-right: 5px">
                  <el-button
                    v-permit="'Deliver.DeliveryApp.Stop'"
                    size="small"
                    :disabled="!appDetail.regionEnable"
                    v-if="
                      appDetail.status != 'failure' &&
                      appDetail.status != 'closed'
                    "
                    @click="handleOperation('stop')"
                    >停止应用</el-button
                  >
                </div>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :disabled="appDetail.regionEnable"
                :content="!appDetail.regionEnable ? '交付环境已经禁用' : ''"
                placement="top"
              >
                <div style="margin-right: 5px">
                  <el-button
                    v-permit="'Deliver.DeliveryApp.Start'"
                    size="small"
                    :disabled="!appDetail.regionEnable"
                    v-if="
                      appDetail.status != 'failure' &&
                      appDetail.status === 'closed'
                    "
                    @click="handleOperation('start')"
                    >启动应用</el-button
                  >
                </div>
              </el-tooltip>
              <el-button
                style="margin-right: 5px"
                v-permit="'Deliver.DeliveryApp.Renew'"
                size="small"
                v-if="appDetail.status != 'failure'"
                @click="handleServiceRenewal"
                >续费</el-button
              >

              <el-tooltip
                class="item"
                effect="dark"
                :disabled="appDetail.regionEnable"
                :content="!appDetail.regionEnable ? '交付环境已经禁用' : ''"
                placement="top"
              >
                <el-badge
                  is-dot
                  class="item"
                  type="primary"
                  v-if="isUpgrade && appDetail.status != 'failure'"
                  v-permit="'Deliver.DeliveryApp.Upgrade'"
                >
                  <el-button
                    style="margin-right: 5px"
                    size="small"
                    :disabled="!appDetail.regionEnable"
                    @click="handleServiceUpgrade"
                    >升级</el-button
                  >
                </el-badge>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :disabled="appDetail.regionEnable"
                :content="!appDetail.regionEnable ? '交付环境已经禁用' : ''"
                placement="top"
              >
                <div style="margin-right: 5px">
                  <el-button
                    size="small"
                    :disabled="!appDetail.regionEnable"
                    v-permit="'Deliver.Domain.Create'"
                    v-if="
                      appDetail.deliveryType != 'sass' &&
                      appDetail.status != 'failure'
                    "
                    @click="DomainVisible = true"
                    >绑定域名</el-button
                  >
                </div>
              </el-tooltip>

              <el-link
                v-if="appDetail.consoleAppURL"
                class="a-button"
                target="_blank"
                :href="`${appDetail.consoleAppURL}/overview`"
                >应用运维</el-link
              >
            </el-col>
          </div>
          <div class="base_info">
            <el-row>
              <label-item
                :span="8"
                label="版本"
                :value="appDetail.appVersion"
              ></label-item>
              <label-item
                :span="8"
                label="套餐"
                v-if="appDetail.combo"
                :custom="true"
                :value="appDetail.combo && appDetail.combo.name"
              >
                <template v-slot:value>
                  <a @click="setShowPackage">
                    {{ appDetail.combo && appDetail.combo.name }}
                  </a>
                  <el-tag
                    style="margin-left: 5px"
                    v-if="appDetail.combo.isTrial"
                    type="success"
                    size="mini"
                    >试用</el-tag
                  >
                </template>
              </label-item>
              <label-item
                :span="8"
                label="开始时间"
                :value="timetrans(appDetail.createTime)"
              ></label-item>
              <label-item
                :span="8"
                label="到期时间"
                :value="timetrans(appDetail.expiredTime)"
              ></label-item>
              <label-item
                :span="8"
                label="交付环境"
                :value="appDetail.regionAlias"
                v-if="appDetail.deliveryType != 'sass'"
              ></label-item>
              <label-item
                :span="8"
                label="交付租户名"
                :custom="true"
                v-if="appDetail.deliveryType != 'sass'"
              >
                <template v-slot:value>
                  <a target="_blank" :href="appDetail.tenantURL">
                    {{ appDetail.tenantAlias }}
                  </a>
                </template>
              </label-item>
              <label-item
                label="状态"
                :span="8"
                :value="handleServiceStatus(appDetail.status) || '-'"
                :style="{
                  color: handleServiceStatus(appDetail.status, true)
                }"
              ></label-item>
              <label-item
                :span="16"
                label="访问域名"
                :custom="true"
                :value="Domain"
              >
                <template v-slot:value>
                  <template v-if="Domain && Domain.length > 0">
                    <div v-for="item in Domain" :key="item.ruleID">
                      <a target="_blank" :href="item.domain">
                        {{ item.domain }}
                      </a>
                    </div>
                  </template>
                  <span v-else>-</span>
                </template>
              </label-item>
            </el-row>
          </div>
        </div>
        <div v-if="appDetail.deliveryType != 'sass'">
          <h2 class="tit-box">应用运行监控</h2>
          <el-row>
            <el-col :span="7">
              <chart-card
                :loading="false"
                title="平均响应时间（ms）"
                :total="queryTog2(requestTimeRange) | NumberFormat"
              >
                <el-tooltip
                  content="平均响应时间，单位毫秒"
                  placement="top"
                  slot="action"
                >
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
                <div>
                  <mini-area :data="queryRangeTog2(requestTimeRange)" />
                </div>
              </chart-card>
            </el-col>
            <el-col :span="7" :offset="1">
              <chart-card
                :loading="false"
                title="吞吐率（dps）"
                :total="queryTog2(appRequestRange) | NumberFormat"
              >
                <el-tooltip
                  content="过去一分钟平均每5s的请求次数"
                  placement="top"
                  slot="action"
                >
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
                <div>
                  <mini-area :data="queryRangeTog2(appRequestRange)" />
                </div>
              </chart-card>
            </el-col>
            <el-col :span="7" :offset="1">
              <chart-card
                :loading="Loading"
                title="在线人数"
                :total="queryTog2(onlineNumberRange) | NumberFormat"
              >
                <el-tooltip
                  content="过去5分钟的独立IP数量"
                  placement="top"
                  slot="action"
                >
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
                <div>
                  <mini-bar :data="queryRangeTog2(onlineNumberRange)" />
                </div>
              </chart-card>
            </el-col>
          </el-row>
        </div>
        <!-- 订单详情 -->
        <div
          class="detail_info_box"
          v-permit="'Market.MarketWarningNotify.List'"
        >
          <div class="tit">预警信息</div>
          <div class="detail_table">
            <public-table
              :loading="Loading"
              :column="column"
              :tableData="warningData"
            >
              <template v-slot:atWhen="{ row }">
                <div>{{ timetrans(row.atWhen) }}</div>
              </template>
              <template v-slot:handleTime="{ row }">
                <div>{{ timetrans(row.handleTime) }}</div>
              </template>
              <template v-slot:operation="{ row }">
                <el-button
                  size="mini"
                  type="text"
                  v-permit="'Market.MarketWarningNotify.Update'"
                  v-if="row.handleStatus == 'waiting'"
                  @click="handleMessage(row)"
                  >处理</el-button
                >
              </template>
            </public-table>
          </div>
        </div>
      </div>
      <no-data v-if="noData" />
      <DialogBindingDomain
        v-if="DomainVisible"
        @handleClose="handleCloseDomain"
        :dialogVisible="DomainVisible"
        :Domain="Domain"
        :appID="deliverID"
        :marketID="marketID"
      />
      <DialogServiceUpgrade
        v-if="ServiceRenewalVisible"
        @handleClose="handleCloseServiceRenewal"
        :dialogVisible="ServiceRenewalVisible"
        :appID="deliverID"
        :marketID="marketID"
        :appDetail="appDetail"
        :packages="upgradePackages"
      />
      <Renew
        @handleClose="
          () => {
            this.RenewVisible = false;
          }
        "
        v-if="RenewVisible"
        :dialogVisible="RenewVisible"
        :appID="deliverID"
        :marketID="marketID"
        :appDetail="appDetail"
      />
      <handle-message
        :marketID="marketID"
        :messageID="handleMessageID"
        :dialogVisible="showHandleMessage"
        :onSuccess="handleMessageSuccess"
        :onClose="() => (showHandleMessage = false)"
      />
      <el-dialog
        width="400px"
        v-if="appDetail.combo"
        :visible.sync="packageShow"
        title="套餐详情"
      >
        <el-row>
          <label-item
            label="套餐名称"
            :value="appDetail.combo && appDetail.combo.name"
          ></label-item>
          <label-item label="套餐价格" :custom="true">
            <template v-slot:value>
              {{ appDetail.combo.price }}元/{{
                useCycle[appDetail.combo.billCycle]
              }}
            </template>
          </label-item>
        </el-row>
        <el-divider content-position="center">套餐指标</el-divider>
        <el-row>
          <template v-for="item in appDetail.combo.items">
            <label-item
              v-if="item"
              :key="item.name"
              :label="item.showName"
              :value="item.value"
            ></label-item>
          </template>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
const defaultListQuery = {
  page: 1,
  size: 10,
  resourceType: 'deliveryApp'
};
import { timetrans, numFilter } from '@/utils/validate';
import { errorHandle } from '@/utils/error';
import { getDeliveryAppDetailApi, appReDelivery } from '@/api/delivery';
import { handleServiceStatus } from '@/utils/dictionary';
import { queryTog2, queryRangeTog2 } from '@/utils/monitorDataUtil';
import DialogBindingDomain from '@/components/Dialog/BindingDomain/index.vue';
import DialogServiceUpgrade from '../components/upgrade.vue';
import { ChartCard, MiniBar, MiniArea } from '@/components';
import HandleMessage from '../../warninginfo/components/handleMessage';
import { getUpgradePackage } from '@/api/appStore';
import { havePerm } from '@/utils/auth';
import { fetchAppInfo } from '@/api/app';
import Renew from '../components/renew.vue';
export default {
  name: 'DeliveryInfo',
  components: {
    HandleMessage,
    DialogBindingDomain,
    DialogServiceUpgrade,
    ChartCard,
    MiniBar,
    MiniArea,
    Renew
  },
  data() {
    return {
      queryTog2,
      queryRangeTog2,
      Domain: [],
      useCycle: {
        week: '周',
        month: '月',
        quarter: '季',
        year: '年'
      },
      DomainVisible: false,
      packageShow: false,
      RenewVisible: false,
      ServiceRenewalVisible: false,
      handleServiceStatus,
      type: 'deliverydetails',
      identity: 'merchants',
      timetrans,
      listQuery: defaultListQuery,
      Loading: true,
      appDetail: {},
      total: 1,
      warningData: [],
      column: [
        {
          prop: 'messageContent',
          label: '预警信息'
        },
        {
          prop: 'atWhen',
          label: '开始时间',
          scopeStatus: true
        },
        {
          prop: 'handleTime',
          label: '处理时间',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          width: '148px',
          scopeStatus: true
        }
      ],
      appMonitoringInfo: false,
      requestTimeRange: {},
      appRequestRange: {},
      onlineNumberRange: {},
      showHandleMessage: false,
      handleMessageID: '',
      noData: false,
      orderType: '',
      isUpgrade: false,
      upgradePackages: [],
      marketAppDetail: null
    };
  },
  created() {
    if (havePerm('Deliver.DeliveryApp.Get')) {
      this.getdeilveryAppsInfo();
    }
    if (havePerm('Market.MarketWarningNotify.List')) {
      this.fetchWarningInfo();
    }
    if (havePerm('Deliver.Domain.List')) {
      this.fetchBindingDomain();
    }
    if (havePerm('Deliver.DeliveryApp.Upgrade')) {
      this.loadUpgradePackage();
    }
  },

  filters: {
    filterNum(num, decimal) {
      return numFilter(num, decimal);
    }
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    deliverID() {
      return this.$route.params.deliverID;
    },
    eid() {
      return this.$store.state.enterprise.enterpriseInfo.eid;
    }
  },
  methods: {
    setShowPackage() {
      this.packageShow = true;
    },
    handleReDelivery() {
      appReDelivery({ marketID: this.marketID, appID: this.deliverID })
        .then((re) => {
          this.$message.success('重新交付任务已发起');
          this.getdeilveryAppsInfo();
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    loadUpgradePackage() {
      getUpgradePackage({
        marketID: this.marketID,
        appID: this.deliverID
      }).then((re) => {
        if (re) {
          this.upgradePackages = re;
          if (this.upgradePackages.length > 0) {
            this.isUpgrade = true;
          }
        }
      });
    },
    handleMessage(row) {
      this.showHandleMessage = true;
      this.handleMessageID = row.messageID;
    },
    handleMessageSuccess() {
      this.showHandleMessage = false;
      this.$message.success('处理异常信息成功');
      this.getdeilveryAppsInfo();
      this.fetchWarningInfo();
    },
    fetchBindingDomain() {
      this.$store
        .dispatch('fetchStoreDeliveryDomains', {
          appID: this.deliverID,
          marketID: this.marketID
        })
        .then((res) => {
          if (res) {
            this.Domain = res;
          }
        })
        .catch((err) => {
          this.Loading = false;
          errorHandle(err);
        });
    },
    handleServiceRenewal() {
      this.RenewVisible = true;
    },
    handleServiceUpgrade() {
      this.ServiceRenewalVisible = true;
    },
    handleCloseDomain(updata) {
      this.DomainVisible = false;
      if (updata) {
        this.fetchBindingDomain();
      }
    },
    handleCloseServiceRenewal() {
      this.getdeilveryAppsInfo();
      this.fetchWarningInfo();
      this.loadUpgradePackage();
      this.ServiceRenewalVisible = false;
    },
    getDomainURL(item) {
      if (item.certificate_id) {
        return 'https://' + item.domain_name;
      }
      return 'http://' + item.domain_name;
    },
    handleOperation(action) {
      const str = action === 'start' ? '是否启动应用' : '是否停止服务';
      this.handleOperations(
        str,
        'OperationDeliveryApps',
        { appID: this.deliverID, marketID: this.marketID, action },
        '操作成功，应用状态延迟刷新'
      );
    },
    handleFallback() {
      this.$router.push({
        name: 'deliveryAppsrManage',
        params: {
          enterpriseID: this.eid
        }
      });
    },
    getdeilveryAppsInfo() {
      getDeliveryAppDetailApi({
        marketID: this.marketID,
        appID: this.deliverID
      })
        .then((res) => {
          this.Loading = false;
          if (res) {
            this.appDetail = res;
            if (
              res.status &&
              res.status != 'released' &&
              res.deliveryType != 'sass'
            ) {
              if (havePerm('Deliver.DeliveryApp.Metrics')) {
                this.fetchStoreDeilveryAppsMonitoring();
              }
              if (havePerm('Market.Application.Get')) {
                this.loadMarketAppDetail(res.combo && res.combo.appKeyID);
              }
            }
          }
        })
        .catch((err) => {
          this.Loading = false;
          if (err && err.code == 20001) {
            this.noData = true;
            return null;
          }
          errorHandle(err);
        });
    },
    fetchWarningInfo() {
      this.$store
        .dispatch(
          'fetchStoreWarningInfo',
          Object.assign(
            {},
            {
              marketID: this.marketID,
              resourceID: this.deliverID
            },
            this.listQuery
          )
        )
        .then((res) => {
          this.warningData = res.messages;
          this.Loading = false;
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    fetchStoreDeilveryAppsMonitoring() {
      this.$store
        .dispatch('fetchStoreDeilveryAppsMonitoring', {
          marketID: this.marketID,
          appID: this.deliverID
        })
        .then((res) => {
          if (res && res.length > 0) {
            this.appMonitoringInfo = res;
            res[0].monitors.map((item) => {
              const { data, monitor_item } = item;
              if (monitor_item === 'request_time') {
                this.requestTimeRange = data;
                // 获取应用平均响应时间监控数据
              }
              if (monitor_item === 'request') {
                this.appRequestRange = data;
                // 获取应用吞吐率监控数据
              }
              if (monitor_item === 'request_client') {
                this.onlineNumberRange = data;
                // 在线人数
              }
            });
          }
          if (this.timers) {
            return null;
          }
          this.timers = setInterval(
            this.fetchStoreDeilveryAppsMonitoring,
            10000
          );
        });
    },
    handleReleaseresources() {
      this.handleOperations(
        '是否释放资源',
        'PutReleaseApplication',
        { marketID: this.marketID, appID: this.deliverID },
        '释放成功'
      );
    },
    handleOperations(title, interfaceName, data, successMessage, errorMessage) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.Loading = true;
          this.$store
            .dispatch(interfaceName, data)
            .then(() => {
              this.Loading = false;
              this.$message.success(successMessage);
              if (this.timer) {
                return null;
              }
              this.timer = setInterval(this.getdeilveryAppsInfo, 2000);
            })
            .catch((err) => {
              this.Loading = false;
              errorHandle(err);
            });
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    loadMarketAppDetail(id) {
      if (!id) {
        return;
      }
      fetchAppInfo({ marketID: this.marketID, appID: id })
        .then((re) => {
          this.marketAppDetail = re;
        })
        .catch((err) => {
          errorHandle(err);
        });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timers);
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mintit-box {
  margin-bottom: 10px;
}
.tit-box {
  font-size: 18px;
  line-height: 30px;
  margin: 30px 0 20px 0;
}
.detailsTitle {
  color: #777777;
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.cens {
  text-align: center;
  padding: 30px;
  h6 {
    font-weight: 300;
    font-size: 20px;
    text-align: center;
  }
}

.titles {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #2c3e50;
}

.detail-container {
  width: 80%;
  padding: 20px 20px 20px 20px;
  margin: 20px auto;
}

.operate-container {
  background: #f2f6fc;
  height: 80px;
  margin: -20px -20px 0;
  line-height: 80px;
}

.operate-button-container {
  margin-right: 20px;
}

.table-layout {
  margin-top: 20px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  height: 60px;
  line-height: 40px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  overflow: hidden;
}

.table-cell-title {
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 10px;
  background: #f2f6fc;
  text-align: center;
  font-size: 14px;
  color: #303133;
}
.domainShow {
  line-height: 13px;
  margin-bottom: 10px;
}
.a-button {
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 0px 10px;
  line-height: 32px;
  font-size: 12px;
  border-radius: 4px;
  text-decoration: none;
}

.a-button:hover {
  border: 1px solid #1890ff;
  color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// src/views/deliverManage/apps/detail/index.vue